import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/utils";
import { ArrowUp, Square } from "lucide-react";
import React from "react";

interface SendButtonProps {
  flowSession?: { status: string } | null;
  handleStopFlowSession: () => void;
  cancelFlowSessionPending: boolean;
  message?: string;
  iconClassName?: string;
  sendButtonClassName?: string;
  stopButtonClassName?: string;
  onSend?: (params: any) => Promise<void>;
  handleSendMessage: () => void;
  isSendButtonDisabled: boolean;
}

export const SendButton: React.FC<SendButtonProps> = ({
  flowSession,
  handleStopFlowSession,
  cancelFlowSessionPending,
  message,
  iconClassName,
  sendButtonClassName,
  stopButtonClassName,
  onSend,
  handleSendMessage,
  isSendButtonDisabled,
}) => {
  if (flowSession?.status === "processing") {
    return (
      <Button
        onClick={handleStopFlowSession}
        title="Stop generating"
        className={cn("size-9 p-0", stopButtonClassName)}
        size="icon"
        variant="primary"
        disabled={cancelFlowSessionPending}
      >
        <Square className="!h-3 !w-3 fill-current" />
      </Button>
    );
  }

  if (typeof onSend === "function") {
    return (
      <Tooltip delayDuration={0}>
        <TooltipTrigger asChild>
          <Button
            onClick={handleSendMessage}
            data-onboarding-target="chat-send-button"
            variant="accent"
            className={cn(
              "size-9 p-0 transition-all duration-200",
              sendButtonClassName,
            )}
            disabled={isSendButtonDisabled}
            size="icon"
            title="Send"
          >
            <ArrowUp className={cn("h-5! w-5!", iconClassName)} />
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          <span>{message?.trim() && "Let's send it 'Enter'"}</span>
        </TooltipContent>
      </Tooltip>
    );
  }

  return null;
};
